import { siFacebook, siInstagram, siYoutube } from 'simple-icons'

const ICONS = {
  siFacebook,
  siInstagram,
  siYoutube,
} as const

export type SimpleIconName = keyof typeof ICONS

type BrandIconProps = {
  name: SimpleIconName
  size?: number
  color?: string
  className?: string
}

export function BrandIcon({
  name,
  size = 20,
  color = 'currentColor',
  className,
}: BrandIconProps) {
  const icon = ICONS[name]

  if (!icon) return null

  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={color}
      className={className}
      aria-label={icon.title}
    >
      <path d={icon.path} />
    </svg>
  )
}
